// extracted by mini-css-extract-plugin
export default {"editTags":"edit_editTags__xlwaf","header":"edit_header__njutR","backward":"edit_backward__-KGS-","form":"edit_form__ZNnEj","rotate":"edit_rotate__asFZp"};